import { getOrCreateSessionId } from "./qrSession";

export type QrSessionCorrelation = {
  sessionId?: string;
  posthogProperties: {
    qr_session_id?: string;
  };
};

export const resolveQrSessionCorrelation = (): QrSessionCorrelation => {
  const sessionId = getOrCreateSessionId();

  return {
    sessionId,
    posthogProperties: {
      qr_session_id: sessionId,
    },
  };
};
